<template src="./reply.html"></template>

<script lang="ts">
import domUtils from 'util/dom-utils'
import AnswerReplyForm from 'components/answers/AnswerReplyForm.vue'
import Byline from 'objects/byline/Byline.vue'


// tslint:disable-next-line:variable-name
const Reply = {
  data() {
    return {
      showReplyForm: false
    }
  },
  props: {
    depth: {
      type: Number,
      default: 1
    },
    originSiteKey: String,
    reply: Object
  },
  inject: {
    soloQuestionCtx: {
      from: 'soloQuestionCtx',
      default: {}
    }
  },
  components: {
    'tt-reply-form': AnswerReplyForm,
    'tt-byline': Byline
  },
  computed: {
    controlsId() {
      // id for aria-controls on reply button.  id is on reply form
      return `tt-reply-form-${this.reply.id}`
    },
    menuItems() {
      return [{
        name: 'reply',
        title: this.$msg('answer.reply'),
        iconName: 'reply',
        cntrlsId: this.controlsId,
        expanded: this.showReplyForm.toString()
      }]
    }
  },
  methods: {
    closeForm() {
      this.showReplyForm = false
      // TT-11853 - should focus back on "Relpy", but complicated by mobile.
      // tries to focus on desktop first, then on mobile if not found
      const bylineEl = this.$refs.byline.$el
      domUtils.focus(() => bylineEl.querySelector('.tt-o-byline__options-item--reply'))
        .catch(() => domUtils.safeFocus(() => bylineEl.querySelector('.tt-o-byline__menu-trigger')))
    },
    menuItemSelected(menuItem) {
      if (menuItem.name === 'reply') {
        this.showReplyForm = true
      }
    }
  },
  beforeCreate() {
    // eslint-disable-next-line global-require
    this.$options.components.Reply = Reply
  },
  created() {
    this.showReplyForm = this.soloQuestionCtx.value?.openReplyForReplyId === this.reply.id
  }
}
export default Reply
</script>

<style lang="scss" src="./reply.scss"></style>
